export const CUSTOMER: string = "CUSTOMER";
export const ADMIN: string = "ADMIN";
